export type BootProgressFn = (percent: number) => void;

declare global {
    interface Window {
        __bootSetProgress?: BootProgressFn;
        __bootHide?: () => void;
    }
}

/** Update the instant HTML boot loader (visible before the main bundle runs). */
export function BootSetProgress(percent: number): void {
    const safe = Math.max(0, Math.min(100, percent));
    window.__bootSetProgress?.(safe);
}

/** Hide the instant boot loader once the in-game loading UI is ready. */
export function BootHide(): void {
    window.__bootHide?.();
}
